import WellBeing from './WellBeing'

export default WellBeing
